import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import FeedbackForm from '@/components/feedback/FeedbackForm';

export default function FeedbackPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0E0E23] via-[#1A1A3E] to-[#0E0E23] text-white" data-testid="public-feedback-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-6 text-center">
          <h1 className="font-syne text-3xl sm:text-4xl font-bold text-white">Help shape EntrepreNatives</h1>
          <p className="text-zinc-400 mt-2 text-sm">Your honest take goes straight to the founder. 15 questions · 2 minutes.</p>
        </div>
        <FeedbackForm source="survey" />
      </div>
      <Footer />
    </div>
  );
}
